import api from "../api.js";
import config from "../../pwaConfig.json";
import db from "../../services/IndexDBStorage";
import { getSelectedBoardAndGradeFromLocal } from "./userProfileService";
// import store from "store";
import store from "../../store/store";
import Axios from "axios";

export async function getUserContent(queryString) {
  const { user } = store.getState();
  const isPrimaryGrade = user
    ? ["1", "2", "3", "4", "5"].includes(user.grade_name)
    : false;

  let url = `${config.apiEndPoint}/${
    isPrimaryGrade ? "feed-primary" : "feed"
  }/learning?disableConcepts=true&boardId=${queryString}`;

  return await api.get(url.split(" ").join(""));
}

export function getLRSContent(queryString) {
  let url = `${config.apiEndPoint}` + `/lrs?verb=COMPLETED` + queryString;

  return api.get(url.split(" ").join(""));
}

export async function getUserContentIfAvailable(queryString) {
  let { data: userData } = await getUserContent(queryString);
  //console.log("userData", userData);
  if (
    userData &&
    userData.content.subjects &&
    userData.content.subjects.length > 0
  ) { 
    return userData;
  }
  //return null;
}

export async function getSubjectsFromLocal() {
  //let userData = getUserProfileData();
  const subjects = await db.subjectContent
    .where("user")
    .equals("user")
    .toArray();
  if (subjects) {
    // console.log("subjects", subjects);
    return subjects;
  }
  return null;
  //console.log("userProfileData", userProfileData);
}

export async function getFeedRailFromLocal(asset) {
  let feedRailArray = [];
  let count = await db.feedRailDataUpdated.count();
  let index = 0;
  do {
    let element = await db.feedRailDataUpdated
      .where("index")
      .equals(index)
      .toArray();
    feedRailArray.push(element[0]);
    index++;
  } while (index < count);
  let feedRail = feedRailArray.filter((rail) => rail.asset_type == asset);
  // const feedRail = await db.feedRailDataUpdated
  //   .where("asset_type")
  //   .equals(asset)
  //   .toArray();
  // // const feedRail = await db.feedRailData.toArray();
  if (feedRail && feedRail.length > 0) {
    // console.log("feedRail ", feedRail);
    return feedRail[0];
  }
  return null;
  //console.log("userProfileData", userProfileData);
}

export async function getFeedRailFromLocalSequentially() { // getting data sequentially through indexedDB
  let feedRailArray = [];
  let count = await db.feedRailDataUpdated.count();
  let index = 0;
  do {
    let element = await db.feedRailDataUpdated
      .where("index")
      .equals(index)
      .toArray();
    feedRailArray.push(element[0]);
    index++;
  } while (index < count);
  if (feedRailArray && feedRailArray.length > 0) {
    return feedRailArray;
  }
  return null;
  //console.log("userProfileData", userProfileData);
}

export async function getLRSDataFromLocal() {
  const lrs = await db.lrsSync.where("user").equals("user").toArray();
  if (lrs && lrs.length) {
    // console.log("LRS", lrs);
    return lrs[0].data;
  }
  return null;
}

export async function getLRSSyncDataByChapter(chapterSlug) {
  const lrs = await db.lrsSync
    .where("learn_object.chapterSlug")
    .equals(chapterSlug)
    // .reverse()
    .sortBy("context.timestamp");

  // console.log("arrChapterdata", lrs);
  return lrs;
  // }
  return null;
}
export async function getLRSSyncData(subjectslug, learnObjectId) {
  if (subjectslug && learnObjectId) {
    var lrs = await db.lrsSync
      .where("[learn_object.subjectSlug+learn_object_id]")
      .equals([subjectslug, learnObjectId])
      // .reverse()
      .sortBy("context.timestamp");
  } else {
    var lrs = await db.lrsSync.reverse().sortBy("context.timestamp");
  }

  // .toArray();

  // if (lrs && lrs.length) {
  //   let arr = lrs[0].data;

  //   console.log({ arr });
  //   arr &&
  //     Array.isArray(arr) &&
  //     arr.sort(
  //       (d1, d2) =>
  //         new Date(d2.context.timestamp).getTime() -
  //         new Date(d1.context.timestamp).getTime()
  //     );

  // console.log("arrdata", lrs);
  return lrs;
  // }
  return null;
}
async function getLRSSyncPendingData() {
  let lrs = await getLRSSyncData();
  if (lrs && lrs.length > 0) {
    let arr = lrs.filter((d1) => {
      if ("isSavedToserver" in d1) {
        if (d1.isSavedToserver) {
          //     console.log("lrddata inner false", d1);
          return false;
        } else {
          //     console.log("lrddata true", d1);
          return true;
        }
      } else {
        //    console.log("lrddata False", d1);
        return false;
      }
    });

    //  console.log("arrPendingdata", arr);
    return arr;
  }
  return null;
}
export async function syncLRSDataWithServer() {
  let pendingLRSData = await getLRSSyncPendingData();
  // console.log("pendingLRSData", pendingLRSData);
  if (pendingLRSData && pendingLRSData.length > 0) {
    let updatedPendingData = pendingLRSData.map((objectLRS) => {
      objectLRS.isSavedToserver = true;
      return objectLRS;
    });
    let result = await sendLRSDataTOServer(updatedPendingData);
    if (result) {
      const userData = await getSelectedBoardAndGradeFromLocal();
      const queryStringForLRS =
        `&user_id=` +
        userData.userId +
        `&board_name=` +
        userData.selectedBoard +
        `&grade_name=` +
        userData.selectedGrade;
      const lrsSyncData = await getLRSContent(queryStringForLRS);
      //    console.log("lrsSyncData", lrsSyncData);
      await saveLRSSyncDataToLocalStorage(lrsSyncData.data.body, true);
    }
  }
}

async function sendLRSDataTOServer(data) {
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const { data: validationResponse } = await api.post(
      `${config.apiEndPoint}/insert-records`,
      data,
      {
        headers: headers,
      }
    );

    return validationResponse;
  } catch (error) {
    return null;
    console.log("Error Response from LRS API", error);
  }
}

export async function getSelectedSubjectFromLocal(slug) {
  //let userData = getUserProfileData();
  const subjects = await db.subjectContent
    .where("user")
    .equals("user")
    .toArray();
  if (subjects && subjects.length > 0) {
    // console.log("subjects", subjects);

    let filteredSubjects = subjects[0].data.filter(
      (subject) => subject.slug === slug
    );
    if (filteredSubjects && filteredSubjects.length > 0) {
      return filteredSubjects[0];
    }
  }
  return null;
  //console.log("userProfileData", userProfileData);
}

export async function getSelectedChapterFromLocal(subjectslug, chapterslug) {
  //let userData = getUserProfileData();
  const subjects = await db.subjectContent
    .where("user")
    .equals("user")
    .toArray();
  if (subjects && subjects.length > 0) {
    // console.log("subjects", subjects);

    let filteredSubjects = subjects[0].data.filter(
      (subject) => subject.slug === subjectslug
    );
    if (filteredSubjects && filteredSubjects.length > 0) {
      let filteredChapter = filteredSubjects[0].chapter.filter(
        (chapter) => chapter.slug === chapterslug
      );
      if (filteredChapter && filteredChapter.length > 0) {
        return filteredChapter[0];
      }
    }
  }
  return null;
  //console.log("userProfileData", userProfileData);
}
export async function getNextTopicFromLocal(
  subjectslug,
  chapterslug,
  currentTopic
) {
  let chapter = await getSelectedChapterFromLocal(subjectslug, chapterslug);
  if (chapter) {
    let index = chapter.topic.findIndex((x) => x.slug === currentTopic);
    if (index >= 0) {
      if (index === chapter.topic.length - 1) {
        return { islast: true, nextrTopic: {} };
      } else {
        return { islast: false, nextrTopic: chapter.topic[index + 1] };
      }
    }
  }
  return null;
}
export async function getSelectedTopicFromLocal(
  subjectslug,
  chapterslug,
  topicslug
) {
  //let userData = getUserProfileData();
  const subjects = await db.subjectContent
    .where("user")
    .equals("user")
    .toArray();
  if (subjects && subjects.length > 0) {
    // console.log("subjects", subjects);

    let filteredSubjects = subjects[0].data.filter(
      (subject) => subject.slug === subjectslug
    );
    if (filteredSubjects && filteredSubjects.length > 0) {
      let filteredChapter = filteredSubjects[0].chapter.filter(
        (chapter) => chapter.slug === chapterslug
      );
      if (filteredChapter && filteredChapter.length > 0) {
        let filteredTopic = filteredChapter[0].topic.filter(
          (topic) => topic.slug === topicslug
        );
        if (filteredTopic && filteredTopic.length > 0) {
          return filteredTopic[0];
        }
      }
    }
  }
  return null;
  //console.log("userProfileData", userProfileData);
}
/*
this.state.selectedBoard +
        `&gradeId=` +
        this.state.selectedGrade +
        `&schoolId=` +
        this.props.match.params.schlId +
        `&language=` +
        this.state.selectedLanguage
*/

export async function saveSubjectDataToLocalStorage(data) {
  if (data) {    
    if(db.subjectContent)
      db.subjectContent.clear();
    db.subjectContent.add({ user: "user", data }).then(() => {});
  }
}

export async function saveFeedRailDataToLocalStorage(data) {
  if (data) {
    data.map(async (obj) => {
      await db.feedRailDataUpdated.put({ ...obj }).then(() => {});
    });
  }
}

export async function saveLRSSyncDataToLocalStorage(data, isClear = false) {
  if (data) {
    if (isClear) await db.lrsSync.clear();
    // console.log("Datat to saveLRS ", data);
    data.map(async (obj) => {
      await db.lrsSync.put({ ...obj }).then(() => {});
    });
  }
}

export async function getSubjectDataToDisplay(queryString) {
  // let subjectontentData = await getSubjectsFromLocal();
  // // subjectontentData = null;
  // if (subjectontentData == null) {
  let subjectontentData = await getUserContentIfAvailable(queryString);
  if (
    subjectontentData.content.subjects &&
    subjectontentData.content.subjects.length != 0
  ) {
    saveSubjectDataToLocalStorage(subjectontentData.content.subjects);
    subjectontentData.feed.items.forEach((element,index) => {
      let indexObject = {
        index: index
      }
      let newElement = Object.assign(element, indexObject )
      return newElement;
    });
    saveFeedRailDataToLocalStorage(subjectontentData.feed.items);
    return subjectontentData.content.subjects;
  } else {
    alert("Sorry, No data available");
  }
  // } else {
  //   // alert("Sorry, No data available");
  //   return subjectontentData[0].data
  // }
  // } else {
  //   return data[0].data;
  // }
}
export async function storeRating(topicslug, rating) {
  db.rating.put({ topicslug: topicslug, rating: rating }).then(() => {});
}
export async function getRating(topicslug) {
  let objRating = await db.rating.where("topicslug").equals(topicslug).first();
  return objRating;
}
export async function getBase64AndHitS3Api(
  evt,
  questionId,
  userId,
  assessmentId = 123
) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(evt);
    reader.onload = async function (upload) {
      const b64 = upload.target.result.replace(/^data:image.+;base64,/, "");
      const responseApi = await uploadS3Image(
        evt.name,
        questionId,
        b64,
        userId,
        assessmentId
      );
      if (responseApi != "undefined") {
        const Data = {
          data: { link: responseApi.data.location },
          status: 200,
          success: true,
        };
        resolve(Data);
      } else {
        reject(responseApi);
      }
    };
  }).catch((error) => {
    console.log(error);
  });
}
export async function uploadS3Image(
  imageName,
  questionId,
  encodedImage,
  userId,
  assessmentId = 123
) {
  return new Promise((resolve, reject) => {
    Axios.post(config.apiEndPoint + "/image-upload", {
      imageName: imageName,
      assessmentId: assessmentId,
      userId: userId,
      questionId: questionId,
      encodedImage: encodedImage,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        console.log(error);
      });
  }).catch((error) => {
    console.log(error);
  });
}
